

<template>
    <div class="mobileTeam h100">
      <mobileHeader></mobileHeader>
      <div class="page page-4">
        <div class="page4Warp flexB h100">
          <div class="zwHeader w100"></div>
          <div class="content flex1 w100">
            <div class="title fb fAb">
              <div>Team</div>
              <div class="mobileBak">
                <mobileBak :home-index="3"></mobileBak>
              </div>
            </div>
            <div class="list">
              <TeamView :teamList="teamList"></TeamView>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>

import TeamView from "@/components/Team/mobile.vue";
import mobileHeader from "@/components/Common/MobileHeader.vue";
import mobileBak from "@/components/Common/mobileBak.vue";

export default {
  components: {mobileBak, mobileHeader, TeamView},
  props:{
    teamList:{
      type:Array,
      default() {
        return [];
      }
    }
  },
}
</script>
<style scoped lang="scss">
.page-4{
  height: 100%;
  background-image: url("../../assets/image/mobile/m_bg_4.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .page4Warp{
    .mobileBak{
      position: absolute;
      right: 1.3rem;
      top: 50%;
      transform: translateY(-50%);
      z-index: 10;
    }
    .content{
      color: #fff;
      display: flex;
      align-items: center;
      flex-direction: column;
      overflow: hidden;
      .title{
        font-size: 1.5rem;
        padding: 1rem;
        position: relative;
        width: 100%;
        text-align: center;
        box-sizing: border-box;
      }
      .list{
        padding: 0 1.3rem;
        flex:1;
        overflow: hidden;
        overflow-y: auto;
        padding-bottom: 1rem;
      }
    }
  }
}
</style>
